document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-contract')
    if (section) {
        const box = document.querySelector(".section-contract__data-list");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        gsap.fromTo(entry.target, {
                            opacity: 0,
                            left: "10%"
                        }, {
                            opacity: 1,
                            left: "4%",
                            duration: 1,
                            ease: "power2.out",
                        });

                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        observer.observe(box);
    }
})